import { Children, cloneElement, isValidElement, useRef, useState } from "react";

function FormWrapper(props) {
    const {
      children,
      formId,
      onSubmit,
      focusableId,
      ...rest
    } = props;

    const [validation, setValidation] = useState({});
    const [continueFailedOnClick, sectContinueFailed] = useState(false);
    const formRef = useRef();
    const passableProps = {
      ...rest,
      children,
      validation,
      setValidation,
      focusableId
    };
    if (!formId) {
      return children
    }
    const validForm = formRef.current?.checkValidity();
    passableProps.formInvalid = (continueFailedOnClick === rest?.stepKey) && !validForm;
    const enhancedChildren = Children.map(children, child => {
      if (isValidElement(child)) {
        return cloneElement(child, passableProps);
      }
      return child;
    });

    return (
      <form
        ref={formRef}
        noValidate={false}
        id={formId}
        onSubmit={(currentForm) => {
          currentForm.preventDefault();
          const res = onSubmit(currentForm)
          if(res?.stepKey && !res.isStepComplete) {
            sectContinueFailed(res?.stepKey);
          }
          return false;
        }}
      >
        {enhancedChildren}
      </form>
    );
  }

export default FormWrapper;
